import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchAllAsync,
  selectAgentesTransportadores,
} from '../../features/transportador-internacional/transportadorInternacionalSlice';

import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectAgenteTransportadorAutocomplete({
  label,
  name,
  initialValues,
  aereoOnly = true,
  disabled,
  required,
  ...restProps
}) {
  const dispatch = useDispatch();

  const list = useSelector(selectAgentesTransportadores);

  useEffect(() => {
    dispatch(fetchAllAsync());
  }, []);

  const listFiltered = useMemo(() => {
    const base = list || [];
    if (aereoOnly) {
      return base.filter((item) => item?.viaTransporte?.description?.includes('AEREA'));
    }
    return base;
  }, [list, aereoOnly]);

  const [defaultValue, setDefaultValue] = useState({ id: null, description: '' });

  useEffect(() => {
    const currentId = _.get(initialValues, name);
    const value = listFiltered.find((item) => item?.id === currentId);

    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [listFiltered, initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item?.code || ''} - ${item?.description || ''}`,
  });

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={listFiltered}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.description ? `${item?.description}` : '')}
      getOptionValue={(item) => item?.id}   // <<< grava ID numérico no form
      disabled={disabled}
      required={required}
      {...restProps}
    />
  );
}
